// extracted by mini-css-extract-plugin
export default {"catalogBlocks":"Catalog_catalogBlocks__Qr9lI","block":"Catalog_block__E2wlm"};